mutation AssignSupportRequest($id: ID!, $assigneeId: ID) {
  assignSupportRequest(id: $id, assigneeId: $assigneeId) {
    id
    assignee {
      id
      displayName
      email
    }
  }
}
